import * as React from "react";
import Avatar from "react-avatar";
import { Button } from "../components/Modal";
import { GetCurrentLoggedInUser, ROLE_CLAIM } from "../account/AccountStore";
import { GetAdmins, IdentityUser, RemoveClaim } from "../users/UserStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AdminsIndex = () => {
    const [admins, setAdmins] = React.useState([] as IdentityUser[]);

    React.useEffect(() => {
        GetCurrentLoggedInUser().then((response) => {
            if (response.claims.some((c) => c.type === ROLE_CLAIM && c.value === "SuperAdmin")) {
                GetAdmins().then((res) => {
                    setAdmins(res.data);
                });
            }
        });
    }, []);

    const removeAdminClaim = (userId) => () => {
        RemoveClaim(userId, ROLE_CLAIM, "Admin").then(() => {
            GetAdmins().then((res) => {
                setAdmins(res.data);
            });
        });
    };

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Header Section */}
            <div className="flex items-center gap-3 pb-6 border-b border-gray-200 mb-6">
                <FontAwesomeIcon icon={["fad", "user-shield"]} className="text-3xl text-purple-500" />
                <div>
                    <h1 className="text-3xl font-bold text-gray-900">Admins</h1>
                    <p className="text-sm text-gray-600 mt-1">Manage system administrators and their permissions</p>
                </div>
            </div>

            {/* Admins Table */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "5%" }}>
                                    Avatar
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "25%" }}>
                                    Name
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "25%" }}>
                                    Email
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "15%" }}>
                                    Phone Number
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: "20%" }}>
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {admins.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="px-6 py-12 text-center">
                                        <FontAwesomeIcon icon={["fad", "users-slash"]} className="text-4xl text-gray-300 mb-3" />
                                        <p className="text-gray-500">No administrators found</p>
                                    </td>
                                </tr>
                            ) : (
                                admins.map((user, i) => (
                                    <tr key={i} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <Avatar name={user.firstName} src={user.photo} size="50" round={true} />
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm font-medium text-gray-900">{user.firstName}</div>
                                            <div className="text-xs text-gray-500 font-mono">{user.id}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">{user.email || "-"}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">{user.phoneNumber || "-"}</div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                            <Button variant="outline-danger" onClick={removeAdminClaim(user.id)}>
                                                <FontAwesomeIcon icon={["fad", "user-minus"]} className="mr-2" />
                                                Remove Admin Claim
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
